/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import BaseLogic from "../../utils/BaseLogic";

import { fetchLocalizedPolicyInformation } from "../../api/legal/policiesApi";
import { LocalizedPolicyInformation } from "../../api/legal/models/policies";
import { InvalidNetworkResponse } from "../../api/types";

interface Props {
  localizedPolicyId: string;
}

interface State {
  localizedPolicyData: LocalizedPolicyInformation | null;
  isLoading: boolean;
  error: Error | null;
}

export default class LocalizedPolicyLogic extends BaseLogic<State> {
  private readonly props: Props;

  constructor(props: Props) {
    super();
    this.props = props;
    this.state = {
      isLoading: false,
      localizedPolicyData: null,
      error: null,
    };
  }

  async init() {
    await this.fetchLocalizedPolicy();
  }

  private async fetchLocalizedPolicy() {
    const { localizedPolicyId } = this.props;
    const { isLoading } = this.state;
    if (isLoading) return;

    await this.setState({ isLoading: true });
    try {
      const { response, error } = await fetchLocalizedPolicyInformation(localizedPolicyId);
      if (error) throw error;
      if (!response) throw new InvalidNetworkResponse();
      await this.setState({ localizedPolicyData: response.data });
    } catch (error) {
      await this.setState({ error });
    } finally {
      await this.setState({ isLoading: false });
    }
  }
}
